import { getMonth, getISODay } from 'date-fns';
import format from 'date-fns/format';
import { ru } from 'date-fns/locale';

export const MONTH_NAME_RU_MAP = {
  0: 'Январь',
  1: 'Февраль',
  2: 'Март',
  3: 'Апрель',
  4: 'Май',
  5: 'Июнь',
  6: 'Июль',
  7: 'Август',
  8: 'Сентябрь',
  9: 'Октябрь',
  10: 'Ноябрь',
  11: 'Декабрь',
};

export const DAY_OF_WEEK_NAME_SHORT_RU_MAP = {
  1: 'Пн',
  2: 'Вт',
  3: 'Ср',
  4: 'Чт',
  5: 'Пт',
  6: 'Сб',
  7: 'Вс',
};

export const dateFnsFormat = {
  dateToAge(date) {
    return new Date().getFullYear() - new Date(date).getFullYear() || 'Не корректен';
  },
  readableDays(date) {
    return format(new Date(date), 'dd');
  },
  readableDate(date) {
    if (!date) {
      return null;
    }

    return format(new Date(date), 'dd.MM.yyyy');
  },
  readableDateWithShortYear(date) {
    return format(new Date(date), 'dd.MM.yy');
  },
  readableDateWithoutYear(date) {
    return format(new Date(date), 'dd.MM');
  },
  readableDateWithTime(date) {
    if (!date) {
      return null;
    }

    return format(new Date(date), 'dd.MM.yyyy (HH:mm)', { locale: ru });
  },
  readableTime(date) {
    if (!date) {
      return null;
    }

    return format(new Date(date), 'HH:mm');
  },
  readableDateTime(date) {
    if (!date) {
      return null;
    }

    return format(new Date(date), 'dd.MM.yyyy HH:mm');
  },
  readableDateWithMonth(date) {
    if (!date) {
      return false;
    }

    return format(new Date(date), 'dd MMMM yyyy HH:mm', { locale: ru });
  },
  readableShortDateWithMonth(date) {
    if (!date) {
      return false;
    }

    return format(new Date(date), 'dd MMMM yyyy', { locale: ru });
  },
  dateShort(date) {
    if (!date) {
      return false;
    }

    return format(new Date(date), 'dd.MM.yyyy');
  },
  readableMonthName(date) {
    return MONTH_NAME_RU_MAP[getMonth(new Date(date))];
  },
  readableWeekNameShort(date) {
    return DAY_OF_WEEK_NAME_SHORT_RU_MAP[getISODay(new Date(date))];
  },
};
